import * as Scrivito from "scrivito";

const OpenStreetMapWidget = Scrivito.provideWidgetClass("OpenStreetMapWidget", {
  attributes: {
    markers: ["widgetlist", { only: "MarkerWidget" }],
  },
  extractTextAttributes: ["markers"],
});

export default OpenStreetMapWidget;
